import type { ComponentProps } from 'react';
import { LightLineIcon } from 'ui';
import type { UserTodo } from '../../../../types';
import { BaseTodoWidgetItem } from '../base-todo-widget-item';

type P = {
  className?: string;
  todo: UserTodo;
  type?: ComponentProps<typeof BaseTodoWidgetItem>['type'];
};

const UserTodoWidgetItem = ({ className, todo, type }: P) => (
  <BaseTodoWidgetItem
    additionalDescription="Express yourself with a profile picture! Your phone number, date of birth, and timezone are only shared with your organization’s administrators."
    className={className}
    description="Make it yours!"
    icon={<LightLineIcon />}
    path={todo.path}
    timeConfig={{ options: { display: 'time', mode: 'by' }, time: todo.endTime }}
    title="Onboarding"
    type={type}
  />
);

export default UserTodoWidgetItem;
